var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-testid": "interior-area-form" } },
    [
      !_vm.value.type
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between bg-cream px-2 sm:px-5 py-3 rounded-t-sm",
              },
              [
                _c("h3", { staticClass: "font-semibold" }, [
                  _vm._v("What is your area?"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "focus:outline-none",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("delete", _vm.index)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Remove")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-3 h-3" },
                      [_c("IconCrossSmall")],
                      1
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "grid grid-cols-2 gap-x-4 gap-y-2 items-center px-2 sm:px-5 py-5 rounded-b-sm bg-cream bg-opacity-50",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "col-span-2 sm:col-span-1",
                    attrs: { for: `area-type-select-${_vm.index}` },
                  },
                  [_vm._v("What size is the room?")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-span-2 sm:col-span-1" },
                  [
                    _c("SelectMenu", {
                      attrs: {
                        id: `area-type-select-${_vm.index}`,
                        "test-id": "area-type-select",
                        options: _vm.areaTypeOptions,
                        placeholder: "Choose...",
                      },
                      model: {
                        value: _vm.areaTypeValue,
                        callback: function ($$v) {
                          _vm.areaTypeValue = $$v
                        },
                        expression: "areaTypeValue",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _c(_vm.formComponent(), {
            tag: "component",
            attrs: {
              index: _vm.index,
              value: _vm.value,
              label: _vm.formLabel(),
            },
            on: {
              input: (area) => _vm.$emit("input", area),
              delete: function ($event) {
                return _vm.$emit("delete", _vm.index)
              },
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }